module.exports = __webpack_public_path__ + "img/search-icon.d0896ab3.svg";